import { render, staticRenderFns } from "./Infography.vue?vue&type=template&id=70bc7f01&"
import script from "./Infography.vue?vue&type=script&lang=js&"
export * from "./Infography.vue?vue&type=script&lang=js&"
import style0 from "./Infography.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports